import { render, staticRenderFns } from "./trigger_year.vue?vue&type=template&id=0a9b1184&scoped=true&"
import script from "./trigger_year.vue?vue&type=script&lang=js&"
export * from "./trigger_year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b1184",
  null
  
)

export default component.exports